export default {
	methods: {
		isGeneGlobeProduct({products, selected}) {
			if (!selected) return false;
			const selectedKeys = selected.map((product) => product.updated);
			const selectedProducts = products.filter((product) => selectedKeys.includes(product.key));
			return selectedProducts.some((product) => product.itemType === 'GeneGlobe');
		},

		isCustomWorkStep(step) {
			return step.hasOwnProperty('customContent');
		},

		isCustomProduct(step) {
			if (this.isCustomWorkStep(step)) return false;
			const {selected} = step;
			return selected.length === 1 && selected[0].updated.includes('custom-product');
		},

		isNotEmpty(step) {
			return step.selected?.length > 0 || this.isCustomWorkStep(step);
		},
	},
};
